import axios from "axios";
import api from "./api";
import {
  ListAcaoQualificacao,
  AcaoQualificacao,
  ListAcoesDisponiveisInscricao,
  Tipologia,
  Modalidade,
  TurmaAcao,
  RetornoGerarTurma,
  TurmaAcaoInsert,
  TurmaResponsavel,
  ResumoVagasTurma,
  CriterioAprovacaoTurma,
  PublicoTurma,
  RegraEspecialTurmaResponse,
  TurmasDisponiveisAcaoResponse,
  InscricaoTurmaResponse,
  InscritosTurmaResponse,
  CsvImportResult,
  NotaManualResponse,
  PresencaManualResponse,
  PresencaTurmaLinkResponse,
  TipoPresencaTurma,
  AcaoAnoCount,
  AcoesPorAno,
  AcaoSituacaoCount,
} from "../types/acao";

export interface AcoesListFilters {
  ano?: number;
  situacao?: string;
  tipoOferta?: string;
  ordenacao?: string;
}

export async function findAllAcoesQualificacao(
  currentPage: number,
  perPage: number,
  searchNome?: string,
  searchModalidade?: number,
  searchTipologia?: number,
  tema?: number,
  searchDataInicio?: string,
  searchDataFim?: string,
  listFilters: AcoesListFilters = {},
): Promise<ListAcaoQualificacao> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/acoes/all`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      params: {
        page: currentPage,
        perPage,
        searchNome,
        searchModalidade,
        searchTipologia,
        tema,
        searchDataInicio,
        searchDataFim,
        ano: listFilters.ano,
        situacao: listFilters.situacao,
        tipo_oferta: listFilters.tipoOferta,
        ordenacao: listFilters.ordenacao,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data?.data ?? response.data;
  } catch (error) {
    console.error("Erro ao buscar as aÃ§Ãµes de qualificação:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar as aÃ§Ãµes de qualificação",
    );
  }
}

const getAuthenticatedHeaders = () => {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token não encontrado");
  }

  return { Authorization: `Bearer ${token}` };
};

export async function findAcoesAnosCount(): Promise<AcaoAnoCount[]> {
  const response = await api.get(
    `${process.env.REACT_APP_API_URL}/acoes/anos`,
    {
      params: { count_only: true },
      headers: getAuthenticatedHeaders(),
    },
  );

  return response.data?.data ?? response.data ?? [];
}

export async function findAcoesPorAno(): Promise<AcoesPorAno[]> {
  const response = await api.get(
    `${process.env.REACT_APP_API_URL}/acoes/anos`,
    {
      headers: getAuthenticatedHeaders(),
    },
  );

  return response.data?.data ?? response.data ?? [];
}

export async function findAcoesSituacoes(): Promise<AcaoSituacaoCount[]> {
  try {
    const response = await api.get(
      `${process.env.REACT_APP_API_URL}/acoes/situacoees`,
      {
        headers: getAuthenticatedHeaders(),
      },
    );

    return response.data?.data ?? response.data ?? [];
  } catch {
    const response = await api.get(
      `${process.env.REACT_APP_API_URL}/acoes/situacoes`,
      {
        headers: getAuthenticatedHeaders(),
      },
    );

    return response.data?.data ?? response.data ?? [];
  }
}

export async function findAcoesFavoritas(
  currentPage: number,
  perPage: number,
  listFilters: AcoesListFilters = {},
): Promise<ListAcaoQualificacao> {
  const response = await api.get(
    `${process.env.REACT_APP_API_URL}/acoes/favoritas`,
    {
      params: {
        page: currentPage,
        perPage,
        ano: listFilters.ano,
        situacao: listFilters.situacao,
        tipo_oferta: listFilters.tipoOferta,
        ordenacao: listFilters.ordenacao,
      },
      headers: getAuthenticatedHeaders(),
    },
  );

  return response.data?.data ?? response.data;
}

export async function addAcaoFavorita(acaoId: number): Promise<void> {
  await api.post(
    `${process.env.REACT_APP_API_URL}/acoes/${acaoId}/favoritos`,
    {},
    {
      headers: getAuthenticatedHeaders(),
    },
  );
}

export async function removeAcaoFavorita(acaoId: number): Promise<void> {
  await api.delete(
    `${process.env.REACT_APP_API_URL}/acoes/${acaoId}/favoritos`,
    {
      headers: getAuthenticatedHeaders(),
    },
  );
}

export async function findAcaoQualificacao(
  acaoId: string,
): Promise<AcaoQualificacao> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/acoes/${acaoId}`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;
  } catch (error) {
    console.error("Erro ao consultar ação de qualificação:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao consultar ação de qualificação",
    );
  }
}

export async function createAcaoQualificacao(
  data: FormData,
): Promise<AcaoQualificacao> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/acoes`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await axios.post(apiUrl, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(`Erro ao cadastrar a ação de qualificação: ${error}`);
  }
}

export async function updateAcaoQualificacao(
  acaoId: string,
  data: FormData,
): Promise<AcaoQualificacao> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/acoes/atualizar/${acaoId}`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await axios.post(apiUrl, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(`Erro ao atualizar a ação de qualificação: ${error}`);
  }
}

export async function findAllTipologias(): Promise<Tipologia[]> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/tipologias`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;
  } catch (error) {
    console.error("Erro ao buscar tipologias:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar tipologias",
    );
  }
}

export async function findAllModalidades(): Promise<Modalidade[]> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/modalidades`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;
  } catch (error) {
    console.error("Erro ao buscar modalidades:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar modalidades",
    );
  }
}

export async function findAllModalidadesAcao(): Promise<Modalidade[]> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/acoes/modalidades`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;
  } catch (error) {
    console.error("Erro ao buscar modalidades:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar modalidades",
    );
  }
}

export async function findAllTemas(): Promise<Modalidade[]> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/temas`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;
  } catch (error) {
    console.error("Erro ao buscar temas:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar temas",
    );
  }
}

export async function findAllTurmasAcao(acaoId: string): Promise<TurmaAcao[]> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/acao/${acaoId}`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;
  } catch (error) {
    console.error("Erro ao buscar turmas da ação:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar turmas da ação",
    );
  }
}

export async function findAllAcoesDisponiveisInscricao(
  currentPage: number,
  perPage: number,
  searchNome?: string,
  searchTipoAcao?: number,
  searchModalidade?: number,
  tema?: number,
  searchPeriodoInicio?: string,
  searchPeriodoFim?: string,
  ordenacao?: string,
): Promise<ListAcoesDisponiveisInscricao> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/acoes/all`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token nao encontrado");
    }

    const response = await api.get(apiUrl, {
      params: {
        page: currentPage,
        perPage,
        include_turmas_disponiveis: true,
        searchNome,
        searchTipoAcao,
        searchModalidade,
        tema,
        searchPeriodoInicio,
        searchPeriodoFim,
        ordenacao,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar as acoes disponiveis para inscricao:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar as acoes disponiveis para inscricao",
    );
  }
}

export async function findTurmasDisponiveisAcao(
  acaoId: string,
): Promise<TurmasDisponiveisAcaoResponse> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/acoes/${acaoId}/turmas/disponiveis`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token nao encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar turmas disponiveis da acao:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar turmas disponiveis da acao",
    );
  }
}

export async function realizarInscricaoTurma(
  turmaId: number,
): Promise<InscricaoTurmaResponse> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/inscricao`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token nao encontrado");
    }

    const response = await api.post(
      apiUrl,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao realizar inscricao na turma",
    );
  }
}

export async function findMinhasInscricoes(
  currentPage: number,
  perPage: number,
  searchNome?: string,
  searchTipoAcao?: number,
  searchModalidade?: number,
  tema?: number,
  searchPeriodoInicio?: string,
  searchPeriodoFim?: string,
  situacao?: string,
  ordenacao?: string,
): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/inscricoes`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token nao encontrado");
    }

    const response = await api.get(apiUrl, {
      params: {
        page: currentPage,
        perPage,
        searchNome,
        searchTipoAcao,
        searchModalidade,
        tema,
        searchPeriodoInicio,
        searchPeriodoFim,
        situacao,
        ordenacao,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar Inscrições do participante:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar Inscrições do participante",
    );
  }
}

export async function findResumoMinhasInscricoes(
  searchNome?: string,
  searchTipoAcao?: number,
  searchModalidade?: number,
  tema?: number,
  searchPeriodoInicio?: string,
  searchPeriodoFim?: string,
  situacao?: string,
): Promise<{
  inscricoes_ativas: number;
  em_andamento: number;
  concluidas: number;
  certificados_disponiveis: number;
}> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/inscricoes/resumo`;
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token nao encontrado");
  }

  const response = await api.get(apiUrl, {
    params: {
      searchNome,
      searchTipoAcao,
      searchModalidade,
      tema,
      searchPeriodoInicio,
      searchPeriodoFim,
      situacao,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data?.data ?? {};
}

export async function cancelarInscricaoTurma(
  turmaId: number,
): Promise<InscricaoTurmaResponse> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/inscricao`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token nao encontrado");
    }

    const response = await api.delete(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao cancelar inscricao",
    );
  }
}

export async function findTurmasRegraEspecialAcao(
  acaoId: string,
): Promise<number[]> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/acao/${acaoId}/regra-especial`;
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token não encontrado");
  }

  const response = await api.get(apiUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const result = response.data as RegraEspecialTurmaResponse;
  return result?.data?.turma_ids ?? [];
}

export async function marcarTurmasRegraEspecial(
  acaoId: string,
  turmaIds: number[],
): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/acao/${acaoId}/regra-especial`;
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token não encontrado");
  }

  const response = await axios.post(
    apiUrl,
    {
      turma_ids: turmaIds,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return response.data;
}

export async function gerarTurmasAcao(
  acaoId: string,
  qtdTurmas: number,
): Promise<RetornoGerarTurma> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/gerar`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await axios.post(
      apiUrl,
      {
        acao_id: acaoId,
        qtd_turmas: qtdTurmas,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    throw new Error(`Erro ao gerar turmas para a ação: ${error}`);
  }
}

export async function findTurma(turmaId: string): Promise<TurmaAcao> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;
  } catch (error) {
    console.error("Erro ao consultar a turma:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao consultar a turma",
    );
  }
}

export type DiagnosticoDisponibilidadeTurma = {
  usuario: {
    id: number;
    nome: string;
    cpf: string;
    email: string;
  };
  acao_id: number;
  turma_id: number;
  disponivel: boolean;
  motivos: Array<{
    codigo: string;
    mensagem: string;
  }>;
  turmas_disponiveis_acao: Array<{
    id: number;
    nome: string;
    descricao_modalidade?: string | null;
    data_inicio: string;
    data_fim: string;
    carga_horaria?: number | null;
  }>;
};

export async function diagnosticarDisponibilidadeTurma(
  turmaId: string | number,
  userId: string | number,
): Promise<DiagnosticoDisponibilidadeTurma> {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token não encontrado");
  }

  const response = await api.get("/turmas/diagnostico-disponibilidade", {
    params: {
      turma_id: turmaId,
      user_id: userId,
    },
    headers: {
      Authorization: "Bearer " + token,
    },
  });

  return response.data?.data;
}

export async function findInscritosTurma(
  turmaId: string,
  currentPage: number = 1,
  perPage: number = 10,
): Promise<InscritosTurmaResponse> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/inscritos`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      params: {
        page: currentPage,
        perPage,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar inscritos da turma:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar inscritos da turma",
    );
  }
}

export async function cancelarInscricaoAlunoTurma(
  turmaId: string,
  userId: number,
): Promise<{ success: boolean; message: string }> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/inscricoes/${userId}`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.delete(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao cancelar inscrição do aluno",
    );
  }
}

export async function adicionarAlunoTurma(
  turmaId: string,
  userId: number,
): Promise<{ success: boolean; message?: string; data?: any }> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/inscricoes/adicionar-aluno`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.post(
      apiUrl,
      { user_id: userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao adicionar aluno na turma",
    );
  }
}

export async function cadastrarAdicionarAlunoTurma(
  turmaId: string,
  payload: any,
): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/inscricoes/cadastrar-adicionar-aluno`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.post(apiUrl, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao cadastrar e adicionar aluno na turma",
    );
  }
}

export async function findLinkPresencaAtivoTurma(
  turmaId: string,
): Promise<PresencaTurmaLinkResponse> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/presencas/links/ativo`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar link ativo de Presença",
    );
  }
}

export async function createLinkPresencaTurma(
  turmaId: string,
): Promise<PresencaTurmaLinkResponse> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/presencas/links`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.post(
      apiUrl,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao gerar link de Presença",
    );
  }
}

export async function deleteLinkPresencaTurma(
  turmaId: string,
  codigo: string,
): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/presencas/links/${codigo}`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.delete(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao encerrar link de Presença",
    );
  }
}

export async function createPresencaManualTurma(
  turmaId: string,
  userId: number,
  dataPresenca: string,
  tipo: TipoPresencaTurma,
): Promise<PresencaManualResponse> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/presencas/manual`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.post(
      apiUrl,
      {
        user_id: userId,
        data_presenca: dataPresenca,
        tipo,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao lançar Presença manual",
    );
  }
}

export async function marcarTodosPresencaTurma(
  turmaId: string,
  dataPresenca: string,
): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/presencas/marcar-todos`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.post(
      apiUrl,
      {
        data_presenca: dataPresenca,
        tipo: "PRESENTE",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao marcar presenças da turma",
    );
  }
}

export async function uploadPresencasCsvTurma(
  turmaId: string,
  arquivo: File,
): Promise<CsvImportResult> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/presencas/upload-csv`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const formData = new FormData();
    formData.append("arquivo", arquivo);

    const response = await api.post(apiUrl, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao enviar CSV de presenças",
    );
  }
}

export async function createNotaManualTurma(
  turmaId: string,
  userId: number,
  nota: number,
): Promise<NotaManualResponse> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/notas/manual`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.post(
      apiUrl,
      {
        user_id: userId,
        nota,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao lançar nota manual",
    );
  }
}

export async function uploadNotasCsvTurma(
  turmaId: string,
  arquivo: File,
): Promise<CsvImportResult> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/notas/upload-csv`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const formData = new FormData();
    formData.append("arquivo", arquivo);

    const response = await api.post(apiUrl, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao enviar CSV de notas",
    );
  }
}

export async function processarResultadosTurma(turmaId: string): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/resultados/processar`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.post(
      apiUrl,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao processar resultados da turma",
    );
  }
}

export async function removerTodosPresencaTurma(
  turmaId: string,
  dataPresenca: string,
): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/presencas/remover-todos`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.delete(apiUrl, {
      data: {
        data_presenca: dataPresenca,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error: any) {
    const apiMessage = error?.response?.data?.message;
    if (apiMessage) {
      throw new Error(apiMessage);
    }

    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao remover presenças da turma",
    );
  }
}

export async function updateTurma(
  turmaId: string,
  data: TurmaAcaoInsert,
): Promise<AcaoQualificacao> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    await validatePeriodoTurma(data);

    const response = await axios.put(apiUrl, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(`Erro ao atualizar a turma: ${error}`);
  }
}

export async function duplicarTurma(turmaId: string): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/duplicar`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await axios.post(
      apiUrl,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    throw new Error(`Erro ao duplicar a turma: ${error}`);
  }
}

export async function inactivateTurma(turmaId: string): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/inactivate/${turmaId}`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.delete(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(`Erro ao excluir a turma: ${error}`);
  }
}

export async function inactivateAcao(acaoId: string): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/acoes/inactivate/${acaoId}`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.delete(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(`Erro ao inativar a ação: ${error}`);
  }
}

export async function saveResponsaveisTurma(
  turmaId: string,
  data: any,
): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/responsaveis`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await axios.post(apiUrl, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(`Erro ao cadastrar responsÃ¡veis da turma: ${error}`);
  }
}

export async function findResponsaveisTurma(
  turmaId: string,
): Promise<TurmaResponsavel> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/responsaveis`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data.data;

    return result;
  } catch (error) {
    console.error("Erro ao buscar os responsÃ¡veis da turma:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar os responsÃ¡veis da turma",
    );
  }
}

export async function saveConfigVagasTurma(
  turmaId: string,
  data: any,
): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/vagas/configurar`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await axios.post(apiUrl, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(`Erro ao configurar as vagas para a turma: ${error}`);
  }
}

export async function findResumoVagasTurma(
  turmaId: string,
): Promise<ResumoVagasTurma> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/vagas/resumo`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data.data;

    return result;
  } catch (error) {
    //console.error("Erro ao buscar o resumo de vagas da turma:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar o resumo de vagas da turma",
    );
  }
}

export async function saveCriterioAprovacaoTurma(
  turmaId: string,
  data: any,
): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/criterio-aprovacao`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await axios.post(apiUrl, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(
      `Erro ao configurar o critÃƒÂ©rio de aprovação da turma: ${error}`,
    );
  }
}

export async function findCriterioAprovacaoTurma(
  turmaId: string,
): Promise<CriterioAprovacaoTurma | null> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/criterio-aprovacao`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    if (!result?.success) {
      return null;
    }

    return result.data ?? null;
  } catch (error) {
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar o critÃƒÂ©rio de aprovação da turma",
    );
  }
}

export async function createPublicoTurma(
  turmaId: string,
  data: any,
): Promise<any> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/publico-alvo`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await axios.post(apiUrl, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(`Erro ao configurar o pÃºblico alvo da turma: ${error}`);
  }
}

export async function findPublicoTurma(turmaId: string): Promise<PublicoTurma> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/turmas/${turmaId}/publico-alvo`;

  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data.data;

    return result;
  } catch (error) {
    //console.error("Erro ao buscar o resumo de vagas da turma:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar o pÃºblico alvo da turma",
    );
  }
}

async function validatePeriodoTurma(data: TurmaAcaoInsert): Promise<void> {
  if (!data?.acao_id || !data.data_inicio || !data.data_fim) {
    return;
  }

  const acao = await findAcaoQualificacao(String(data.acao_id));

  if (data.data_inicio < acao.data_inicio) {
    throw new Error(
      "Data de início da turma deve ser maior ou igual Ã  data de início da ação",
    );
  }

  if (data.data_fim > acao.data_fim) {
    throw new Error(
      "Data de tÃ©rmino da turma deve ser menor ou igual Ã  data de tÃ©rmino da ação",
    );
  }
}
